import { render, staticRenderFns } from "./SupervisionHistoryDialog.vue?vue&type=template&id=70b5641e&scoped=true&"
import script from "./SupervisionHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./SupervisionHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionHistoryDialog.vue?vue&type=style&index=0&id=70b5641e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5641e",
  null
  
)

export default component.exports